// src/pages/Profile.tsx  (Clerk <UserProfile /> alapú)
import React, { useContext } from "react";
import { Box, Container, Typography, CircularProgress } from "@mui/material";
import { UserProfile, useUser } from "@clerk/clerk-react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { ThemeContext } from "../contexts/ThemeContext";
import { BRAND, brandPalette } from "../theme/brand";

const Profile: React.FC = () => {
  const { isLoaded, user } = useUser();
  const { darkMode } = useContext(ThemeContext)!;
  const pal = brandPalette(darkMode);

  return (
    <>
      <Navbar />
      <Container maxWidth="xl" sx={{ mt: { xs: 8, md: 10 }, mb: 4, padding: { xs: 1.5, md: 6 } }}>
        <Typography variant="h4" component="h1" align="center" mb={4} fontWeight="bold" sx={{ color: pal.heading, fontSize: { xs: "1.5rem", md: "2.125rem" } }}>
          {isLoaded ? `Üdv, ${user?.firstName ?? ""} 👋` : "Profil betöltése..."}
        </Typography>

        {!isLoaded ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
            <CircularProgress size={80} sx={{ color: pal.accent }} />
          </Box>
        ) : (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            {/* path routing: az App.tsx-ben a route-nak "/profile/*"-nak kell lennie */}
            <UserProfile
              routing="path"
              path="/profile"
              appearance={{
                variables: {
                  colorPrimary: BRAND.purple,
                  borderRadius: "12px",
                },
                elements: {
                  rootBox: { width: "100%", maxWidth: "1000px" },
                  card: {
                    width: "100%",
                    border: darkMode ? "2px solid rgba(252, 198, 50, 0.45)" : "1px solid rgba(109, 27, 119, 0.2)",
                    boxShadow: darkMode ? "0 8px 40px 0 rgba(0, 0, 0, 0.45)" : "0 8px 40px 0 rgba(109, 27, 119, 0.18)",
                  },
                },
              }}
            />
          </Box>
        )}
      </Container>
      <Footer />
    </>
  );
};

export default Profile;